const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

export const getMonths = (numberOfMonths: number) => {
  if (numberOfMonths <= 0) return []

  const currentDate = new Date()
  const currentMonthIndex = currentDate.getMonth()
  const currentYear = currentDate.getFullYear()

  const previousMonthsCount = Math.floor(numberOfMonths / 2)
  const nextMonthsCount = numberOfMonths - previousMonthsCount - 1

  return Array.from({ length: previousMonthsCount + nextMonthsCount + 1 }, (_, index) => {
    const offset = index - previousMonthsCount
    const date = new Date(currentYear, currentMonthIndex + offset, 1)
    const monthIndex = date.getMonth()
    const year = date.getFullYear()
    const monthValue = (monthIndex + 1).toString().padStart(2, '0')

    return {
      title: months[monthIndex],
      dataIndex: `${year}-${monthValue}`,
    }
  })
}
